import React from "react";
import { Guid } from "../../../api/baseApi";
import { DayOfWeek, TimeSlotModel } from "../../../api/channelsApi";
import { addLeadingZero } from "../../../services/common";
import SvgSelector from "../svgSelector/SvgSelector";
import "./Schedule.css"
import { PlayerScheduleOvviredeType, PlayerTimeSlotOverrideModel, PlayerTimeSlotOverrideRequest } from "../../../api/playersApi";

interface ScheduleProps {
    timeSlots: PlayerTimeSlotOverrideModel[],
    onTimeSlotClick: (timeSlot: PlayerTimeSlotOverrideRequest) => void;
}
 
interface ScheduleState {    
}

 
class ScheduleOverride extends React.Component<ScheduleProps, ScheduleState> {
    constructor(props:ScheduleProps){
        super(props)
    }
    
    hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

    
    isSlotOverrideExist = (dayOfWeek : DayOfWeek, hour: number, minutes: number) => {
        const slot = this.props.timeSlots.find(
                timeSlot =>  timeSlot.dayOfWeek == dayOfWeek 
                && timeSlot.hour == hour
                && timeSlot.minute == minutes);

        return slot;
    }

    renderScheduleRow = (hour : number) => {
        const daysOfWeek = [1, 2, 3, 4, 5, 6, 0]

        return <tr key={hour}>
            <td>{addLeadingZero(hour, 2)}:00</td>
            {daysOfWeek.map(it => this.renderScheduleIndicator(hour, it))}   
        </tr>
    }

    renderScheduleIcon = (slot: PlayerTimeSlotOverrideModel | undefined) => {
        switch(slot?.type){
            case PlayerScheduleOvviredeType.Disabled :
                return <span className="active"><SvgSelector title={"cross"} /></span>;
            case PlayerScheduleOvviredeType.Enabled : 
                return <span className="active"><SvgSelector title={"ok"} /></span>;
            case PlayerScheduleOvviredeType.EnabledInSite : 
                return <SvgSelector title={"ok"} />;
            default : return <SvgSelector title={"cross"} />;
        }
    }

    renderScheduleIndicator = (hour: number, dayOfWeek: DayOfWeek) => {

        const firstHalfSlot = this.isSlotOverrideExist(dayOfWeek, hour, 0);
        const secondHafSlot = this.isSlotOverrideExist(dayOfWeek, hour, 30);  

        return <td key={`${dayOfWeek}-${hour}`}>
                    <div className="svg-block">
                        <div onClick={()=>this.props.onTimeSlotClick({dayOfWeek: dayOfWeek, hour: hour, minute: 0})}>
                            {this.renderScheduleIcon(firstHalfSlot)}
                        </div>
                        <div onClick={()=>this.props.onTimeSlotClick({dayOfWeek: dayOfWeek, hour: hour, minute: 30})}>
                            {this.renderScheduleIcon(secondHafSlot)}
                        </div>
                    </div>
                </td>       
    }

    render() { 
        return (
            <table className="table schedule-table">
                <thead>
                    <tr>
                        <td></td>
                        <td>Monday</td>
                        <td>Tuesday</td>
                        <td>Wednesday</td>
                        <td>Thursday</td>
                        <td>Friday</td>
                        <td>Saturday</td>
                        <td>Sunday</td>
                    </tr>
                </thead>
                <tbody>
                    {this.hours.map( it => this.renderScheduleRow(it))}                    
                </tbody>
            </table>
        );
    }
}
 
 
export default ScheduleOverride;